import { useAuth0 } from "@auth0/auth0-react";
import { ReactComponent as FilterActive } from "assets/icons/filter-active-icon.svg";
import { ReactComponent as FilterIcon } from "assets/icons/filter-icon.svg";
import Button from "components/button/Button";
import AlertDialog from "components/Dialog/index.js";
import SearchDownShift from "components/downmshift/DownShift";
import NewDialog from "components/NewDialog/Dialog";
import addDays from "date-fns/addDays";
import { useDisableEnterKey } from "hook/useDisableEnterKey";
import { SubHeader } from "layout/SubHeader";
import AuthService from "Lib/API/Auth";
import moment from "moment";
import AddDeceased from "pages/Yaherzit/NewYahrzeit";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { DateFormetContext } from "../../app/App.js";
import NotAuthorized from "../../components/NotAuthorized";
import { setSelectedDeceased } from "../commonSlice";
import DeceasedTable from "./deceasedTable";
import "./style.scss";
import { FilterClearButton, FilterGoFilterButton, Filters, FilterWrapper, FilterWrapperButtons } from "./Theme.js";
import YahrzeitFilters from "./YahrzeitFilters.jsx";

const initialFilter = {};
const Yaherzit = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState(initialFilter);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [total, setTotal] = useState();
  const [totalMourner, setTotalMourner] = useState();
  const [sortBy, setSortBy] = useState("all");
  const [show, setShow] = useState("");
  const [isYahrzeitActive, setIsYahrzeitActive] = useState(true);
  const { getAccessTokenSilently } = useAuth0();
  const [calendar, setCalender] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const { selectedDeceased } = useSelector((state) => state.CommonStates);
  const [date, setDate] = useState([]);
  const [okayValue, setOkayValue] = useState(false);
  const [isOpenMergePopUp, setIsOpenMergePopUp] = useState(false);
  const [message, setMessage] = useState("");
  const [loadingMerge, setLoadingMerge] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);
  const [firstHit, setFirstHit] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const [yahrzeitFilter, setYahrzeitFilter] = useState({
    accountType: "",
    hasPlaque: "",
    hasMourner: false,
    languageType: "",
    dateType: "all",
  });

  useEffect(() => {
    setPage(0);
  }, [sortBy]);

  useEffect(() => {
    if (endDate < startDate) {
      toastr.error("End Date should be greater than start date.");
      setDateRange([null, null]);
      setDate([]);
    }
  }, [endDate]);

  const getFilterdDeceased = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    AuthService.getFilterdDeceased(page + 1, 30, filters, sortBy, token)
      .then((res) => {
        const result = res?.deceaseds.map((item) => {
          item.id = item._id;
          return item;
        });
        setTotal(res.total);
        setTotalMourner(res.totalMourner);
        setList(result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toastr.error("Error", err?.data?.message);
      });
  };

  useEffect(() => {
    if (!firstHit) return;
    setPage(0);
    setFilters((prev) => ({
      ...prev,
      searchValue: searchValue !== "" ? searchValue : undefined,
    }));
  }, [searchValue]);


  useEffect(() => {
    // setFilters((prev) => ({
    //   ...prev,
    //   searchValue: searchValue !== '' ? searchValue : undefined,
    // }));
    getFilterdDeceased();
    // if (sortBy !== "dateRange") {
    //   setDateRange([null, null]);
    //   setDate([]);
    // }
    if (firstHit) return;
    setFirstHit(true);
  }, [page, refresh, filters, sortBy]);


  let orgInfo = localStorage?.getItem("authorizedModules")
    ? JSON.parse(localStorage?.getItem("authorizedModules"))
    : [];

  useEffect(() => {
    let check =
      orgInfo !== undefined ??
      orgInfo?.map((item) => {
        if (item?.moduleName == "yahrzeit") {
          return setIsYahrzeitActive(item?.active);
        }
      });
    setIsYahrzeitActive(
      orgInfo?.find((item) => item?.moduleName === "members")?.active
    );
  }, []);

  useEffect(() => {
    setCalender(false);
  }, [endDate]);

  const onCheckboxClick = (e, row) => {
    const { checked } = e.target;
    if (checked) {
      const found = list.find((item) => item._id === row._id);
      if (found) {
        dispatch(setSelectedDeceased([...selectedDeceased, row]));
      }
    } else {
      dispatch(
        setSelectedDeceased([
          ...selectedDeceased.filter((item) => item?._id !== row?._id),
        ])
      );
    }
  };


  const predefinedRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
    },
    {
      label: "Tomorrow",
      value: [addDays(new Date(), 1), addDays(new Date(), 1)],
    },
    {
      label: "Next 7 days",
      value: [new Date(), addDays(new Date(), 7)],
    },
    {
      label: "Next 30 days",
      value: [new Date(), addDays(new Date(), 30)],
    },
  ];

  const handleOpenFilters = () => {
    setOpenFilters((prev) => !prev);
  }

  const filterChange = (name, value) => {
    setYahrzeitFilter((prev) => ({ ...prev, [name]: value }));
  };


  const checkFilterApplied = useCallback(() => {
    const isFilterApplied = Object.keys(yahrzeitFilter).some((key) => {
      if (key === "dateType") {
        return yahrzeitFilter[key] !== "all";
      }
      return yahrzeitFilter[key];
    }
    );
    return isFilterApplied || startDate;
  }, [yahrzeitFilter, startDate]);


  const clearFilter = useCallback(() => {
    setDateRange([null, null]);
    setDate([]);
    setPage(0);
    setYahrzeitFilter({
      accountType: "",
      hasPlaque: "",
      hasMourner: false,
      languageType: "",
      dateType: "all",
    });
    setFilters((prev) => ({
      ...prev,
      filter: {
        accountType: undefined,
        hasPlaque: undefined,
        hasMourner: undefined,
        observance: undefined,
      },
      date: undefined,
    }));
    setSortBy("all");
  }, []);

  const handleFilter = useCallback(() => {
    setPage(0);
    setOpenFilters((prev) => !prev);
    setFilters((prev) => ({
      ...prev,
      filter: {
        accountType: yahrzeitFilter.accountType ? yahrzeitFilter.accountType : undefined,
        hasPlaque: yahrzeitFilter.hasPlaque ? "Yes" : undefined,
        hasMourner: yahrzeitFilter.hasMourner ? false : undefined,
        observance: yahrzeitFilter.languageType ? yahrzeitFilter.languageType : undefined,
      },
      date: (startDate && endDate) ? {
        start: moment(startDate).format("MM/DD/YYYY"),
        end: moment(endDate).format("MM/DD/YYYY"),
      } : undefined,
    }));
    setSortBy(yahrzeitFilter.dateType);
  }, [yahrzeitFilter, startDate, endDate]);


  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setIsOpenMergePopUp(false);
  }

  useDisableEnterKey(true);



  return !isYahrzeitActive ? (
    <NotAuthorized title={"Yahrzeit"} />
  ) : (
    <div className="school-classes  pt-10">
      <div className="header">
        <div className="header-tittle">
          <SubHeader
            className="subheader"
            {...{
              title: "Yahrzeits",
              color: "#2455EF",
            }}
          />
        </div>
        <div className="d-flex">
            <Button
              variant="primary"
              onClick={() => setIsOpenMergePopUp(true)}
              style={{ minWidth: "170px" }}
              >
              Add Yahrzeit
            </Button>
        </div>
      </div>
      <hr />
      <div className="mb-5">
        <div className="d-flex align-items-center yahrzeits__filter__bar justify-content-between">
          <SearchDownShift
            items={[]}
            name={searchValue}
            setName={setSearchValue}
            placeHolder="Search"
            autoFocus
          />
          <Filters className="ml-5">
            <Button
              variant="filter"
              onClick={handleOpenFilters}
            >
              {checkFilterApplied() ?
                <FilterActive /> :
                <FilterIcon />
              }
              <span>Filter</span>
            </Button>
          </Filters>

        </div>

        {openFilters && (
          <FilterWrapper>
            <YahrzeitFilters setOpenFilters={setOpenFilters} openFilters={openFilters} handleOpenFilters={handleOpenFilters} filterChange={filterChange} yahrzeitFilter={yahrzeitFilter}

              date={date} setDate={setDate} setDateRange={setDateRange} startDate={startDate} endDate={endDate} />
            <FilterWrapperButtons >
              <Button
                onClick={clearFilter}
                size="md"
                variant="primary-outline"
              >
                <span>Clear</span>
              </Button>
              <Button
                onClick={handleFilter}
                size="md"
                variant="primary"
              >
                <span>Filter</span>
              </Button>
            </FilterWrapperButtons>
          </FilterWrapper>
        )}
      </div>
      <DeceasedTable
        refresh={refresh}
        setRefresh={setRefresh}
        page={page}
        setPage={setPage}
        list={list}
        total={total}
        totalMourner={totalMourner}
        loading={loading}
        setFilters={setFilters}
        sortBy={sortBy}
        endDate={endDate}
        searchValue={searchValue}
        filters={filters}
        onCheckboxClick={onCheckboxClick}
      />
      <NewDialog
        isOpen={isOpenMergePopUp}
        message={message}
        handleClose={closeModal}
        loading={loadingMerge}
        title={"New Yahrzeit"}
        sx={{
          "& .MuiDialog-paperWidthSm": { minWidth: "997.01px", height: "97%" },
        }}
        content={
          <div className="dialog-wrapper">
            <AddDeceased
              setIsOpenMergePopUp={setIsOpenMergePopUp}
              isOpenMergePopUp={isOpenMergePopUp}
              setRefresh={setRefresh}
              refresh={refresh}
              closeModal={() => {
                setIsOpenMergePopUp(false);
              }}
            />
          </div>
        }
        contentStyle={{
          display: "flex",
          justifyContent: "center",
          height: "100%",
        }}
        buttonStyle={{ justifyContent: "right" }}
      ></NewDialog>
      <AlertDialog
        open={confirmClose}
        handleClose={() => setConfirmClose(false)}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </div>
  );
};

export default Yaherzit;
